export const environment = {
  production: true,
  api_url: '/api'
};
